import {global, lm} from "../../appContext";
import {SYSTEM_MEGA_EADM} from "../../constants";
import {IRouteDefinition, ISystem} from "../../index";
import {getHash, isRoutePermissionOkay, setRouteHash} from "../../constants/RouteDefinitions";
import pubsub from "../../pubsub";
import type {IPageShellHeaderActions} from "../page-shell/pageShellHeaderActions";
import {IDialogOptionsComponent} from "../dialog";
import {nsFa} from "../fa/fn";
import i = nsFa.i;

/** Collection commands shown in the page header on every detail tab. */
export function buildSystemAccessActions(
    system: ISystem,
    routeDef: IRouteDefinition,
): IPageShellHeaderActions {
    return {
        quick: [
            {
                icon: 'fa-pencil',
                label: 'edit',
                href: () => getHash('editsystemaccess', {id: system.id}) ?? '',
                validator: () => !system.isreadonly && !system.definitionreadonly,
            },
        ],
        more: [
            {
                icon: 'fa-cog',
                label: 'accessmanagement.collection.actions.generateruleset',
                description: () => lm.t('accessmanagement.collection.actions.generateruleset') ?? '',
                href: () => getHash('systemaccesswizardgenerate-rs-and-mf', {systemid: String(system.id)}) ?? '',
                validator: () => !system.definitionreadonly
                    && isRoutePermissionOkay('createruleset')
                    && isRoutePermissionOkay('createmessageflow'),
            },
            {
                icon: 'fa-plus',
                label: 'accessmanagement.collection.actions.fromgroups',
                description: () => lm.t('accessmanagement.collection.actions.fromgroups') ?? '',
                onClick: () => {
                    const options: IDialogOptionsComponent = {
                        title: 'accessmanagement.collection.actions.fromgroups',
                        content: {
                            name: 'component/systemaccess/dialog/groups-to-permissions',
                            params: {system},
                        },
                    };
                    global.dialogManager.addComponent(options);
                },
                validator: () => !system.definitionreadonly,
            },
            {
                cls: 'btn-destructive explicit',
                icon: 'fa-trash-alt',
                label: 'delete collection',
                onClick: () => global.dialogManager.addComponent({
                    content: {
                        name: 'component/systemaccess/dialog/purge-collection',
                        params: {system},
                    },
                    title: `${i('fa-trash-alt')} ((delete subject|s:((collection|ac)))) <span class="name">[${system.name}]</span>`,
                    onSuccess: () => {
                        global.snackbarData({message: 'subject is deleted|s:((collection))'});
                        if (routeDef.parent) {
                            setRouteHash(routeDef.parent);
                        }
                    },
                    onError: () => pubsub.trigger('collection.needs.refresh'),
                }),
                validator: () => system.name !== SYSTEM_MEGA_EADM
                    && !system.definitionreadonly
                    && isRoutePermissionOkay('createsystemaccess'),
            },
        ],
    };
}
